import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormulaireService } from '../../saisie/formulaire.service';
import { ModalitesService, Modalite } from 'src/app/core/modalites.service';
import { UntypedFormControl } from '@angular/forms';
import { variableIdentifiante } from 'src/app/shared/questionnaire.metadata';
import { Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { ModeRenduService } from 'src/app/saisie/mode-rendu/mode-rendu.service';
import { RolesService } from 'src/app/authentification/roles.service';
import { SaisieService } from 'src/app/saisie/saisie.service';

@Component({
  selector: 'bis-infobar',
  templateUrl: './infobar.component.html',
  styleUrls: ['./infobar.component.css']
})
export class InfobarComponent implements OnInit, OnDestroy {
  public readonly variableJuridiction = 'ielst';
  private modalites: Modalite[] = [];
  private subscriptions: Subscription[] = [];
  private libelleJuridiction: string = '';
  constructor(
    private formulaireService: FormulaireService,
    public modaliteService: ModalitesService,
    public modeRendu: ModeRenduService,
    public ROLES: RolesService,
    public saisieService: SaisieService
  ) {
  }

  ngOnInit() {
    this.subscriptions.push(
      this.modaliteService.getModalites(this.variableJuridiction).subscribe(modalites => {
        this.modalites = modalites;
        // Après la mise à jour des modalités, on met à jour la valeur au cas où
        this.libelleJuridiction = this.saisieService.gestionLibelle(this.identifiantJuridictionValeur, this.modalites);
      })
    );
    this.subscriptions.push(
      this.juridiction.valueChanges.pipe(distinctUntilChanged()).subscribe((identifiantJuridiction) => {
        this.libelleJuridiction = this.saisieService.gestionLibelle(identifiantJuridiction, this.modalites);
      })
    );
  }

  ngOnDestroy() {
    /** Quand le composant est détruit, on arrête de surveiller les changements de valeurs */
    this.subscriptions.forEach(sub => { sub.unsubscribe(); });
  }
  
  /** Retourne le formulaire en cours */
  get questionnaire() {
    return this.formulaireService.getRootForm() || null;
  }
  
  /* identifiant affiché 
    A adapter suivant les variables identifiantes retenues,  ici ielst 
  */
    get identifiantValeur(): string {
      let identifiant = '';
      variableIdentifiante.forEach((nomVariable) => {
        identifiant += '📝 ' + this.questionnaire.get(nomVariable).value;
      });
      return identifiant;
    }

  /* Attention su le champ ielst n'est pas en identifiant zone à appeler comme suit : this.questionnaire.get('nomOnglet').get(this.variableJuridiction)  */
  get juridiction(): UntypedFormControl {
    if (this.questionnaire.get(this.variableJuridiction)) {
      return this.questionnaire.get(this.variableJuridiction) as UntypedFormControl;
    } else {
      console.error('Impossible de trouver la juridiction pour l’afficher dans l’infobar');
      return null;
    }
  }

  get identifiantJuridictionValeur(): string {
    return this.juridiction.value;
  }

  public get libelleJuridictionValeur(): string {
    this.libelleJuridiction = this.saisieService.gestionLibelle(this.juridiction.value, this.modalites);
    return this.libelleJuridiction;
  }

}
